import { ICommand } from 'core-ts-types';
import { PathTask, CurrentTopicsQuery } from 'capability-ng-todos';
import * as _4 from 'lodash4';
import { IDatasource } from 'utility-ts-orm';

export class MyTodosDetailController {
  models: any;
  pageTitle: string;
  constructor(
    private pathTaskDetail: any,
    private taskUpdateFn: any,
    private $stateParams: ng.ui.IStateParamsService,
    private log: any,
    private pathItemPresenterDetailEnum: any,
    private ngCurrentTopicsQuery: CurrentTopicsQuery,
    private loadPathTaskTopicsCommand: ICommand,
    private loadPathTasksCommand: ICommand,
    private EventCategoryEnum: any,
    private ngPathTaskDatastore: IDatasource<PathTask>
  ) {
    this.models = {
      taskDetails: this.pathTaskDetail,
      specialPresenter: this.pathItemPresenterDetailEnum.get(this.pathTaskDetail.root.presenter.key).value,
      resources: this.pathTaskDetail.resource,
      topic: $stateParams.topic,
      task: this.pathTaskDetail.source.task
    };

    if (_4.isEmpty(this.ngPathTaskDatastore.values())) {
      this.loadPathTasksCommand().then(() => {
        this.updateTaskTopic(this.models.task.event, this.models.task.repeated_by);
      });
    } else {
      this.updateTaskTopic(this.models.task.event, this.models.task.repeated_by);
    }

    this.pageTitle = this.EventCategoryEnum.isDateMarker(this.models.task.category) ? 'Event' : 'To-Do';
  }

  updateTaskTopic(eventId: string, repeatedBy: string): void {
    this.loadPathTaskTopicsCommand(eventId, repeatedBy).then(() => {
      this.models.topics = this.ngCurrentTopicsQuery;
    });
  }

  isDismissed(task: PathTask): boolean {
    return this.taskUpdateFn.isDismissed(task);
  }

  isDismissible(task: PathTask): boolean {
    return task.is_dismissible && !this.taskUpdateFn.isCompleted(task);
  }

  getHideText(isDimissed: boolean) {
    return !this.isDismissed(this.models.task) ? 'Hide' : 'Unhide';
  }

  toggleDismissed(task: PathTask): void {
    const initialStatus = task.status;
    task.status = this.taskUpdateFn.getNewStatusAsString(task, initialStatus, true);

    this.taskUpdateFn.toggleDismissed(task, initialStatus, false).then(
      (updatedTask: PathTask) => {
        this.models.task = updatedTask;
        this.pathTaskDetail = { ...this.pathTaskDetail };
      },
      (err: any) => {
        this.models.task.status = initialStatus;
        this.log.user.error(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todos_detail/my_todos_detail_controller.ts